import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'panel-header',
    template: `<ng-content></ng-content>`
})
export class PanelHeader {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/panel/panel.header.component.ts